import React from 'react';

import { StyledMobileBoxSaveButton } from '../utils/Styles/DataBoxStyles';

type Props = {
  disabled: boolean;
  isEditMode: boolean;
  setIsEditMode(value: boolean): void;
  onResetClick(): void;
  onSaveClick(value: unknown): void;
};

const ActivityEditMobileActions = ({
  isEditMode,
  setIsEditMode,
  onSaveClick,
  onResetClick,
  disabled,
}: Props) => {
  const onSave = event => {
    setIsEditMode(false);
    onSaveClick(event);
  };

  const onReset = () => {
    setIsEditMode(false);
    if (onResetClick) onResetClick();
  };

  return (
    <>
      {isEditMode && (
        <StyledMobileBoxSaveButton
          type='submit'
          onClick={onSave}
          disabled={disabled}
        >
          Save
        </StyledMobileBoxSaveButton>
      )}
      <i
        className={`fas fa-${isEditMode ? 'ban' : 'pencil-alt'}`}
        style={{ marginLeft: '10px' }}
        onClick={isEditMode ? onReset : () => setIsEditMode(true)}
      />
    </>
  );
};

export default ActivityEditMobileActions;
